import { useState, useEffect } from 'react';

/**
 * Хук useDarkMode - управление темной темой с сохранением предпочтений в localStorage
 * 
 * @returns {Array} [darkMode, setDarkMode] - Состояние темы и функция для переключения
 */
const useDarkMode = () => {
  // Проверяем предпочтения пользователя в localStorage или системные настройки
  const getUserPreference = () => {
    const savedPreference = localStorage.getItem('darkMode');
    if (savedPreference !== null) {
      return JSON.parse(savedPreference);
    }
    
    // Если нет сохраненных предпочтений, проверяем системные настройки
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  };
  
  const [darkMode, setDarkMode] = useState(getUserPreference());
  
  // Эффект для применения темы при изменении состояния
  useEffect(() => {
    // Сохраняем предпочтения пользователя в localStorage
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    
    // Применяем классы к HTML элементу
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);
  
  // Эффект для отслеживания изменений системных настроек
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = () => {
      // Обновляем состояние только если пользователь не задал явно свои предпочтения
      if (localStorage.getItem('darkMode') === null) {
        setDarkMode(mediaQuery.matches);
      }
    };
    
    // Добавляем слушатель событий для отслеживания изменений системных настроек
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      // Для старых браузеров
      mediaQuery.addListener(handleChange);
    }
    
    // Очистка слушателя при размонтировании компонента
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        // Для старых браузеров
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);
  
  return [darkMode, setDarkMode];
};

export default useDarkMode;